exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-f02c3886] {\n  max-width: 70%;\n}\n", ""]);

// exports
